import { $api } from "../AxiosInstance";

export class ArticleService {
  /**
   * Get all article groups
   * @param {Object} params
   */
  static async getAllGroups(params) {
    return await $api.get("/api/admin/v1/article/all/v1/group/all", params);
  }

  /**
   * Get group by article ID
   * @param {Number} articleId
   */
  static async getGroupById(articleId) {
    return await $api.get("/api/admin/v1/article/v1/group/byId", {
      params: { articleId },
    });
  }

  /**
   * Create new group
   * @param {Object} newGroup
   */
  static async createGroup(newGroup) {
    return await $api.post("/api/admin/v1/article/v1/group/create", newGroup);
  }

  /**
   * Update existing group
   * @param {Object} updateGroup
   */
  static async updateGroup(updateGroup) {
    return await $api.put("/api/admin/v1/article/v1/group/update", updateGroup);
  }

  /**
   * Delete group by ID
   * @param {Number} id
   */
  static async deleteGroup(id) {
    return await $api.delete("/api/admin/v1/article/v1/group/delete", {
      params: { id },
    });
  }

  /**
   * Set group
   * @param {Object} group
   */
  static async setGroup(group) {
    return await $api.post("/api/admin/v1/article/v1/setGroups", group);
  }

  /**
   * Save article ID
   */
  static async saveArticleId() {
    return await $api.post("/api/admin/v1/article/v1/save");
  }

  /**
   * Get all articles
   * @param {Object} params
   */
  static async getArticles(params) {
    return await $api.post("/api/admin/v1/article/v1/all", params);
  }

  /**
   * Get article by ID
   * @param {Number} articleId
   */
  static async getArticle(articleId) {
    return await $api.get("/api/admin/v1/article/all/v1/articleId", {
      params: { articleId },
    });
  }

  /**
   * Update article translations
   * @param {Object} params
   */
  static async updateArticleTranslations(params) {
    return await $api.put("/api/admin/v1/article/v1/update/translation", params);
  }

  /**
   * Save article translations
   * @param {Object} params
   */
  static async saveArticleTranslations(params) {
    return await $api.post("/api/admin/v1/article/v1/save/translation", params);
  }

  /**
   * Upload image for article
   * @param {File} file
   * @param {Number} articleTranslationId
   */
  static async uploadImage(file, articleTranslationId) {
    return await $api.post("/api/admin/v1/article/v1/file", file, {
      params: { articleTranslationId },
    });
  }

  /**
   * Upload main image for article
   * @param {File} file
   * @param {Number} articleTranslationId
   */
  static async uploadMainImage(file, articleTranslationId) {
    return await $api.post("/api/admin/v1/article/v1/mainImg", file, {
      params: { articleTranslationId },
    });
  }

  /**
   * Delete image by file ID
   * @param {Number} fileId
   */
  static async deleteImage(fileId) {
    return await $api.delete(`/api/admin/v1/article/v1/file`, {
      params: { fileId },
    });
  }

  /**
   * Delete article by ID
   * @param {Number} id
   */
  static async deleteArticle(id) {
    return await $api.delete("/api/admin/v1/article/v1/delete/id", {
      params: { id },
    });
  }

  /**
   * Save article
   * @param {Object} params
   */
  static async saveArticle(params) {
    return await $api.post("/api/admin/v1/article/v1/save", params);
  }

  /**
   * Set article translation as main
   * @param {Number} articleTranslationId
   */
  static async setMain(articleTranslationId) {
    return await $api.post("/api/admin/v1/article/v1/setMain", {
      articleTranslationId,
      main: true,
    });
  }
}
